import React, { useEffect, useState } from 'react';
import request from '@/services/request.service';
import { toFormData } from '@/utils/convert.util';
// import { getLocaleWordContent, getLocaleObject } from '@/utils/language.util';
import { getServerMessage } from '@/utils/massage.util';
import { getLocaleWordContent } from '@/utils/language.util';

export default function BankAccount({ ModalActions }) {
    const [user, setUser] = useState([]);
    const [check, setCheck] = useState(false);

    const fetchBusinesses = () => {
        getData().then((user) => {
            if (user != null) {
                setUser(user);
            }
        });
    };
    useEffect(fetchBusinesses, []);

    const getData = async () => {
        const rsp = await request.post('/api/account/user_info.php', null).then((response) => response.data);
        //console.log("ModalBankAccount",rsp);
        if (rsp.result < 0) {
            return null;
        } else {
            if (rsp.b_account) {
                setCheck(true);
            }
            return rsp;
        }
    };

    const handleChange = (e) => {
        if (e) e.preventDefault();

        var new_user = { ...user };
        if (e.target.name === 'b_name') {
            new_user.b_name = e.target.value;
            setUser(new_user);
        } else if (e.target.name === 'b_account') {
            new_user.b_account = e.target.value;
            setUser(new_user);
        } else if (e.target.name === 'b_depositor') {
            new_user.b_depositor = e.target.value;
            setUser(new_user);
        }
    };

    const handleSubmit = () => {
        submitData();
    };

    const submitData = async () => {
        const param = { b_name: user.b_name, b_account: user.b_account, b_depositor: user.b_depositor, type: '2' };
        const rsp = await request
            .post('/api/account/user_update.php', toFormData(param))
            .then((response) => response.data);
        if (rsp.result < 0) {
            getServerMessage(rsp.msg).then((msg) => window.alert(msg));
            handleClose();
        } else {
            alert(rsp.msg);
            handleClose();
            return rsp;
        }
    };
    const handleClose = () => {
        ModalActions.showModalEx({ mode: 0 });
    };

    return (
        <div className="popup_01">
            <div className="popup_inner01">
                <div className="pop_bank">
                    <img
                        src={require('@/resources/assets/images/close.png')}
                        className="popup_close"
                        alt="close"
                        onClick={handleClose}
                    />
                    <h2>
                        <div className="inner">{getLocaleWordContent('은행계좌등록')}</div>
                    </h2>
                    <div className="inner">
                        <form className="inputbox">
                            <div className="input_form">
                                <p className="title">{getLocaleWordContent('은행명')}</p>
                                <div className="input_form01">
                                    <input
                                        type="text"
                                        value={user.b_name || ''}
                                        placeholder={getLocaleWordContent('은행명')}
                                        onChange={handleChange}
                                        name="b_name"
                                        className="input01"
                                        readOnly={check ? 'readOnly' : ''}
                                    />
                                </div>
                            </div>
                            <div className="input_form">
                                <p className="title">{getLocaleWordContent('계좌번호')}</p>
                                <div className="input_form01">
                                    <input
                                        type="text"
                                        value={user.b_account || ''}
                                        placeholder={getLocaleWordContent('계좌번호')}
                                        onChange={handleChange}
                                        name="b_account"
                                        className="input01"
                                        readOnly={check ? 'readOnly' : ''}
                                    />
                                </div>
                            </div>
                            <div className="input_form">
                                <p className="title">{getLocaleWordContent('예금주')}</p>
                                <div className="input_form01">
                                    <input
                                        type="text"
                                        value={user.b_depositor || ''}
                                        placeholder={getLocaleWordContent('예금주')}
                                        onChange={handleChange}
                                        name="b_depositor"
                                        className="input01"
                                        readOnly={check ? 'readOnly' : ''}
                                    />
                                </div>
                            </div>
                            <div className="p_form01">
                                <span className="guide_t1 red">{getLocaleWordContent('※주의사항※')}</span>
                                <p className="guide_t2">
                                    1. {getLocaleWordContent('계정정보를 올바르게 입력하지 않으면 거래지 연 및 출금 지연 등 단점이 있을 수 있습니다.')} 
                                </p>
                                <p className="guide_t2">
                                    2. {getLocaleWordContent('은행이름, 계좌번호, 예금주명을 정확히 입력 하시기 바랍니다.')} 
                                </p>
                            </div>
                            <div className="bottom-btn">
                                <input
                                    type="button"
                                    className="b_gray btn01"
                                    data-dismiss="modal"
                                    value={getLocaleWordContent('취소')}
                                    onClick={handleClose}
                                />
                                <input type="button" className="b_blue btn01" value={getLocaleWordContent('저장')} onClick={handleSubmit} />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
